import { UserOutlined } from '@ant-design/icons';
import { Avatar, Flex, Popover } from 'antd';
import React, { Suspense, useState } from 'react';
import { useRelayEnvironment } from 'react-relay';

import LoaderUser from '../../components/LoaderUser';
import { getObjectFromRelayStoreById } from '../../functions';
import { UserType } from '../../types';

interface TaskBoardAssigneeProps {
    userId?: string | null;
    noDisplayEmptyIcon?: boolean;
    displayName?: boolean;
    displayHint?: boolean;
}

export const TaskBoardTaskAssignee: React.FC<TaskBoardAssigneeProps> = ({
    userId,
    displayName,
    noDisplayEmptyIcon,
    displayHint,
}) => {
    const [userData, setUserData] = useState<UserType>();
    const environment = useRelayEnvironment();

    const userFromStore = (userId ? getObjectFromRelayStoreById<UserType>(environment, userId) || {} : {}) as UserType;
    const filterFlexible = userId ? `[{"or":[{"id":"${userId}"}]}]` : undefined;

    const currentUser = userFromStore || userData;

    const contentAvatar = (
        <Avatar size={36} style={{ backgroundColor: '#aaa' }}>
            {currentUser?.first_name}
        </Avatar>
    );

    const fullName = `${currentUser?.first_name} ${currentUser?.last_name}`;

    return (
        <>
            {!Object.keys(userFromStore).length && filterFlexible && (
                <Suspense>
                    <LoaderUser
                        varRequest={{ filter_flexible: filterFlexible }}
                        onUpdateData={(rows) => {
                            if (rows[0]) {
                                setUserData(rows[0]);
                            }
                        }}
                        prefixFetchKey={userId || undefined}
                    />
                </Suspense>
            )}
            {userId ? (
                <Flex gap={10} align={'center'}>
                    {displayHint ? <Popover content={fullName}>{contentAvatar}</Popover> : contentAvatar}

                    {displayName && <span>{fullName}</span>}
                </Flex>
            ) : (
                !noDisplayEmptyIcon && <Avatar size={36} style={{ backgroundColor: '#ссс' }} icon={<UserOutlined />} />
            )}
        </>
    );
};
